import { createClient } from './client';

export const createApi = () => {
  let client: any;

  return {
    initialize({ clientOptions }: { clientOptions: any }) {
      client = createClient(clientOptions);
    },

    getClient() {
      return client;
    },

    setClient(newClient: any) {
      client = newClient;
    },

    getNewAccessToken() {
      // TODO: fill this in
      return Promise.resolve(null);
    },

    // ************ old stuff **************
    logout() {
      return this.post('/api/v0/logout/');
    },

    /* HTTP aliases */
    get(path: string, data?: any, options?: any) {
      let payload: any = {};

      if (data) payload.params = data;
      if (options) payload = Object.assign(payload, options);

      return client.httpClient.get(path, payload);
    },

    post(path: string, data?: any) {
      return client.httpClient.post(path, data);
    },

    put(path: string, data?: any) {
      return client.httpClient.put(path, data);
    },

    delete(path: string, data?: any) {
      return client.httpClient.delete(path, { data });
    },
  };
};

export const api = createApi();
